<template>
    <b-card class="card-accent-light" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-regular fa-heart-pulse"></i> <strong> Lifestyle </strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <lifestyle-base :callback="createPatientLifestyle" borderless />
        </b-collapse>
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import LifestyleBase from './LifestyleBase'
import { mapActions } from "vuex"

export default ComponentExtension.extend({
    name: "life-style",
    components: {
        'lifestyle-base': LifestyleBase
    },
    methods: {
        ...mapActions('health', ['createPatientLifestyle']),
    }
})
</script>
